var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCompleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.9167C3 7.71907 3 6.12028 3.37752 5.58241C3.75503 5.04454 5.25832 4.52996 8.26491 3.50079L8.83772 3.30472C10.405 2.76824 11.1886 2.5 12 2.5C12.8114 2.5 13.595 2.76824 15.1623 3.30472L15.7351 3.50079C18.7417 4.52996 20.245 5.04454 20.6225 5.58241C21 6.12028 21 7.71907 21 10.9167C21 11.3996 21 11.9234 21 12.4914C21 18.1294 16.761 20.8655 14.1014 22.0273C13.38 22.3424 13.0193 22.5 12 22.5C10.9807 22.5 10.62 22.3424 9.89856 22.0273C7.23896 20.8655 3 18.1294 3 12.4914C3 11.9234 3 11.3996 3 10.9167Z",
    stroke: "#00C117",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.9L10.9286 14.5L14.5 10.5",
    stroke: "#00C117",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCompleteIcon);
export default __webpack_public_path__ + "static/media/upload-complete-icon.f162d373b939fdf110fac9f14c97b0fa.svg";
export { ForwardRef as ReactComponent };